export default "__VITE_ASSET__Cz5iTWU$__"